<template>
    <Spinner v-if="displaySpinner" />
    <div class="title-and-controls">
        <h1 class="page-title">{{ stekName }}</h1>
        <div class="controls">
            <Button
                v-if="stek && canDeleteStek"
                severity="secondary"
                @click="deleteStek"
                :label="`Delete ` + stekName"
                icon="pi pi-trash"
            />
        </div>
    </div>
    <div v-if="domains?.length > 0">
        <section :class="{ 'edit': isEditing }">
            <DomainsList :isEditing="isEditing" :domains="domains" />
        </section>
    </div>
    <div v-else>
        <p>No domains found in this Stek.</p>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useDomainsManager } from "@/stores/domains-store";
import DomainsList from "@/components/Domains/DomainsList.vue";
import { useConfirm } from "primevue/useconfirm";
import { useRouter } from "vue-router";
import { useEditManager } from "@/composables/edit-manager";
import { useStekManager, useStekStore } from "@/composables/stek-manager";
import Spinner from "@/shared/Spinner.vue";
import { useOrganizationManager } from "@/composables/organization-manager";
import { useUserManager } from "@/stores/user-store";

const { user } = useUserManager();
const { organization } = useOrganizationManager();
const { stek, isLoadingSteks } = useStekManager();
const { domains, isFetching } = useDomainsManager();
const { isEditing } = useEditManager();
const router = useRouter();

const canDeleteStek = computed(() => {
    // FIXME: Actually check if the user has the correct permissions
    return user.value?.role === "user-manager";
});

const stekName = computed(() => stek.value?.name || "...");
const displaySpinner = computed(() => {
    return isFetching.value || isLoadingSteks.value;
});

const confirm = useConfirm();
const { remove } = useStekStore();

const deleteStek = async () => {
    if (!stek.value) {
        return;
    }
    let message = `This will remove EVERYTHING inside ${stek.value.name}.`;
    message += `\n\nThis will remove ${domains.value.length} domains and their children.`;
    if (domains.value.length) {
        message +=
            "\n\n" + `Domains: ${domains.value.map((d) => d.name).join(",")}.`;
    }
    confirm.require({
        header: "Are you sure?",
        message: message,
        icon: "pi pi-exclamation-triangle",
        rejectProps: {
            label: "Cancel",
            severity: "secondary",
            outlined: true,
        },
        acceptProps: {
            label: "Delete",
            severity: "danger",
        },
        defaultFocus: "reject",
        accept: async () => {
            if (!stek.value || !organization.value) {
                return;
            }
            await remove({ showToast: true });
            router.push(`/${organization.value.name}/steks`);
        },
    });
};
</script>
